import { h } from 'preact'
import { Modal, ModalBody, ModalHeader } from '../modal'

type Log = {
  id: number,
  timestamp: string,
  message: string
}

type Props = {
  isOpen: boolean,
  logs: Array<Log>,
  onClose: () => void,
}

const TestModeLogsModal = ({ isOpen, logs, onClose } : Props) => {
  return (
    <Modal isOpen={isOpen} size='large'>
      <ModalHeader title='Test logs' onClose={onClose} />
      <ModalBody>
        <div class='test-mode-logs-modal'>
          <pre class='logs-container'>
            { logs.map((log: Log) => {
              const timestamp = new Date(log.timestamp).toLocaleString()
              return <p>{timestamp} - {log.message}</p>
            }).reverse() }
          </pre>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default TestModeLogsModal
